import styled from 'styled-components'

export const SignInUpContainer = styled.div`
  width: 1000px;
  display: flex;
  justify-content: space-between;
  margin: 30px auto;

  @media only screen and (max-width: 1100px) {  
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`
